import React from 'react'
import './pdcaemptystate.scss'

export default ({ title, cy }) => {
  return (
    <div className='pdca-empty-state' data-cy={cy}>
      <p>{title}</p>
    </div>
  )
}